import { MenuItem } from 'vue-graphql-models';

export default [
  new MenuItem({
    id: 'homeDhcJobs',
    title: 'Home',
    subtitle: 'Return to Helios App Main Screen (Leave Registration)',
    route: { name: 'home' },
    icon: 'home',
  }),
  new MenuItem({
    id: 'smsDhcJobs',
    title: 'Text Us',
    subtitle: 'Text us to get some help (8 - 6 M-F CST)',
    href: 'sms://+17133649646',
    icon: 'textsms',
  }),
  new MenuItem({
    id: 'callDHCJobs',
    title: 'Call Us',
    subtitle: 'Tap to auto-dial or 405-595-7204',
    href: 'tel://+17133649646',
    icon: 'call',
  }),
  new MenuItem({
    id: 'contactFormDHCJobs',
    title: 'Email Us',
    subtitle: 'Tap to email us anytime (good option for after-hours)',
    route: { name: 'contactForm' },
    icon: 'email',
  }),
];
